import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results"]

  // Lista fissa di esempio, ma puoi caricare dinamicamente da server via fetch/ajax
  suggestions = [
    "Roma",
    "Milano",
    "Torino",
    "Napoli",
    "Firenze",
    "Venezia",
    "Bologna",
    "Genova",
    "Palermo",
    "Catania"
  ]

  search() {
    const query = this.inputTarget.value.toLowerCase()
    this.resultsTarget.innerHTML = ""

    if (query.length === 0) {
      return
    }

    const filtered = this.suggestions.filter(city =>
      city.toLowerCase().startsWith(query)
    )

    filtered.forEach(city => {
      const li = document.createElement("li")
      li.textContent = city
      li.classList.add("list-group-item", "list-group-item-action")
      li.addEventListener("click", () => {
        this.inputTarget.value = city
        this.resultsTarget.innerHTML = ""
      })
      this.resultsTarget.appendChild(li)
    })
  }
}
